












import { Vue, Component, Prop, Emit } from "vue-property-decorator"

@Component
export default class SNavigateBox extends Vue {
    @Prop() private label!: string
    @Prop({ default: "/" }) private to!: string

    @Emit()
    private onNavigate() {
        this.$router.push(this.to)
    }
}
